import { render, staticRenderFns } from "./AddRoundModal.vue?vue&type=template&id=0356e3a2&scoped=true&"
import script from "./AddRoundModal.vue?vue&type=script&lang=js&"
export * from "./AddRoundModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0356e3a2",
  null
  
)

export default component.exports